export const getInterestingStocks = state =>
  state.browserView.interestingStocks;
export const getInterestingStocksLoading = state => state.browserView.loading;
